// extracted by mini-css-extract-plugin
export default {"container":"AuthCallback_container__yS0cV","error":"AuthCallback_error__ZNeTb"};